import styled from '@emotion/styled'
import { Col } from 'react-bootstrap'
import { ITheme } from 'application/utils/type'

interface IReleaseSectionProps {
  isExistingCar?: boolean
  theme: ITheme
}
export const releaseSection = styled.div<IReleaseSectionProps>`
  label: releaseSection;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
`

export const releaseHeader = styled.h3<IReleaseSectionProps>`
  label: releaseHeader;
  color: ${(props) => props.theme.colors.primary};
`

export const releaseSubText = styled.div<IReleaseSectionProps>`
  label: releaseSubText;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: ${(props) => props.theme.font.size.small};
  font-weight: ${(props) => props.theme.font.weight.slightBold};
  margin-bottom: 18px;
`

export const releaseCard = styled.div<IReleaseSectionProps>`
  label: releaseCard;
  display: flex;
  justify-content: center;
  font-size: ${(props) => props.theme.font.size.medium};
  color: ${(props) => props.theme.colors.textDarkblack};
`

export const releaseCardLeftBorder = styled(Col)<IReleaseSectionProps>`
  label: releaseCardLeftBorder;
  background-color: ${(props) =>
    props.isExistingCar
      ? props.theme.colors.alertGrey
      : props.theme.colors.alertGreen} !important;
  width: 9px;
  max-width: 9px;
  padding: 0px;
`

export const releaseCardContent = styled(Col)<IReleaseSectionProps>`
  label: releaseCardContent;
  background-color: ${(props) =>
    props.isExistingCar
      ? props.theme.backgrounds.backGround2
      : props.theme.colors.alertGreen2} !important;
  padding: 24px 24px 0 24px;
`

export const releaseCardHeading = styled.div<IReleaseSectionProps>`
  label: releaseCardHeading;
  font-weight: ${(props) => props.theme.font.weight.slightBold};
  line-height: 24px;
  text-align: left;
`

export const releaseCardDetailLine = styled.div`
  label: releaseCardDetailLine;
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 719px) {
    flex-direction: column;
    text-align: left;
  }
`

export const releaseCardDetailTextSpan = styled.span`
    label releaseCardDetailTextSpan;
    margin-right: 30px;
    @media (max-width: 719px) {
        margin-right: 0px;
    }
`
